module.exports = __webpack_public_path__ + "static/media/Illus-Empty_2@2x.04d2f97a.png";